import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './tag.scss?inline';
import { isValidCssColor } from '@/helpers/color.js';

export default class SotbitTag extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        bgColor: { type: String, attribute: 'bg-color' },
        color: { type: String, attribute: 'color' },
        selected: { type: Boolean },
    };

    constructor() {
        super();

        this.bgColor = '';
        this.color = '';
        this.selected = false;
    }

    render() {
        const styleTemplate = html`<style>
            :host {
                ${isValidCssColor(this.bgColor) ? `--tag-background: ${this.bgColor};` : ''}
                ${isValidCssColor(this.color) ? `--tag-color: ${this.color};` : ''}
            }
        </style>`;

        return html`
            ${this.bgColor || this.color ? styleTemplate : nothing}
            <div class="tag" part="tag">
                <div class="content">
                    <slot name="icon-start"></slot>
                    <span class="text" part="text"><slot></slot></span>
                    <slot name="icon-end"></slot>
                </div>
                ${this.selected
                    ? html`<div class="icon-wrapper" part="icon-wrapper">
                          <sotbit-icon class="icon" size="xs" icon="check" no-padding></sotbit-icon>
                      </div>`
                    : ''}
            </div>
        `;
    }
}
